import { render, staticRenderFns } from "./ChipsInput.vue?vue&type=template&id=71b07b7b&scoped=true&"
import script from "./ChipsInput.vue?vue&type=script&lang=ts&"
export * from "./ChipsInput.vue?vue&type=script&lang=ts&"
import style0 from "./ChipsInput.vue?vue&type=style&index=0&id=71b07b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b07b7b",
  null
  
)

export default component.exports